export default class Standard {

  constructor(standard = {}) {
    this.id = standard.id || null
    this.name = standard.name || ''
    this.description = standard.description || ''
    this.sections = standard.sections || []
  }

  mutations() {
    return {
      setStandard: (state, standard) => state.standard = new Standard(standard),
      clearStandard: (state) => state.standard = new Standard(),
      updateName: (state, name) => state.standard.name = name,
      updateDescription: (state, description) => state.standard.description = description
    }
  }

}